// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"223":"49c69fee3c7d2e697711","678":"871ba7ed7ac4754271d4","843":"082df484ad1e3f6e1354","883":"0ed6fdced52e8af70515"}[chunkId] + ".js";
};